import styled from "styled-components";

export const StyledErrorForm = styled.p`
    font-size: 10px;
    font-weight: 300;
    color: var(--color-error);
`